export default {
  apiUrl: `https://api.market.trackit.io`,
}



// WEBPACK FOOTER //
// ./src/config.js